import React from 'react';

import classes from './Skeleton.scss';

type Props = Record<string, unknown>;

export const Skeleton: React.FC<Props> = () => {
    return <div className={classes.empty} />;
};
